import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  e2eLocators,
  fakeSecretKey
} from '@components/storage-accounts/add-storage-account-wizard/credential-forms/credential-forms.constants';
import { I18NextPipe } from 'angular-i18next';
import { CardGroupComponent, CheckboxComponent, FormGroupComponent, InputComponent, InputPasswordComponent } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared';
import { FTPCredentialForm } from '../credential-forms.model';

@Component({
  selector: 'mbs-credential-form-ftp',
  templateUrl: './credential-form-ftp.component.html',
  styleUrls: ['../credential-forms.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CardGroupComponent,
    CheckboxComponent,
    CommonModule,
    FormGroupComponent,
    I18NextPipe,
    InputComponent,
    InputPasswordComponent,
    ReactiveFormsModule
  ]
})
export class CredentialFormFtpComponent {
  @Input() form: FTPCredentialForm;

  protected readonly fakeSecretKey = fakeSecretKey;
  protected readonly StorageType = StorageType;
  protected readonly e2eLocators = e2eLocators;

  get user(): FormControl {
    return this.form.get('user') as FormControl;
  }

  get password(): FormControl {
    return this.form.get('password') as FormControl;
  }

  get endpoint(): FormControl {
    return this.form.get('endpoint') as FormControl;
  }

  get isPrivateStorage(): FormControl {
    return this.form.get('isPrivateStorage') as FormControl;
  }

  get useSSL(): FormControl {
    return this.form.get('useSSL') as FormControl;
  }

  get keepAlive(): FormControl {
    return this.form.get('keepAlive') as FormControl;
  }

  get usePassiveMode(): FormControl {
    return this.form.get('usePassiveMode') as FormControl;
  }
}
